import type { MemberRemark } from "@/services/types";

// Mirrors the backend limits in groups/service.js (MAX_REMARKS_PER_TICKET, REMARK_RETENTION_DAYS).
export const MAX_REMARKS = 3;
export const REMARK_RETENTION_DAYS = 90;
export const MAX_REMARK_LENGTH = 500;
const DAY_MS = 86_400_000;

/** Local calendar date as YYYY-MM-DD (not UTC — a follow-up "today" means today here). */
function localISODate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function addDays(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return localISODate(d);
}

export type FollowUpTone = "overdue" | "today" | "upcoming";

export function followUpTone(followUpDate: string): FollowUpTone {
  const today = localISODate(new Date());
  if (followUpDate < today) return "overdue";
  if (followUpDate === today) return "today";
  return "upcoming";
}

export function daysUntilDeleted(createdAt: string): number {
  const expiresAt = new Date(createdAt).getTime() + REMARK_RETENTION_DAYS * DAY_MS;
  return Math.max(0, Math.ceil((expiresAt - Date.now()) / DAY_MS));
}

/** Whose remarks the remarks modal shows — built from a group ticket or a report row. */
export interface RemarksTarget {
  groupMemberId: string;
  memberName: string;
  ticketNo: number | string;
  remarks: MemberRemark[];
}
